import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import EdgesensorHighRoundedIcon from '@mui/icons-material/EdgesensorHighRounded';
import ViewQuiltRoundedIcon from '@mui/icons-material/ViewQuiltRounded';
import seolanding from '../../assets/img/seolanding.png';
import landingpage from '../../assets/img/dashreachai.png';

const items = [
  {
    icon: <ViewQuiltRoundedIcon />,
    title: 'ERP Dashboard',
    description:
      'Powerful analytics and data visualiztion plus premium adons for small and medium sized businesses.',
    image: landingpage
  },
  {
    icon: <ViewQuiltRoundedIcon />,
    title: 'Targeted AD & Hyper-Personalization',
    description:
      'We create and manage your AD on all ADTECH platforms with tools such as Google Tags, Google Analytics, Meta Pixels, Instagram, Tiktok etc.',
    image: landingpage
  },
  {
    icon: <EdgesensorHighRoundedIcon />,
    title: 'SEO Optimization with AI',
    description: 'Leveraging advanced AI/ML for content optimization & hyper-personalization.',
    image: seolanding
  },
  {
    icon: <DevicesRoundedIcon />,
    title: 'Available on all platforms',
    description:
      'Our solution aggregates all your digital marketing platforms into one, including Google, Facebook, Instagram, Tiktok, Youtube and more.',
    image: seolanding
  }
];

export default function WhatWeOffer() {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index: number) => {
    setSelectedItemIndex(index);
  };

  const selectedFeature = items[selectedItemIndex];
  return (
    <Container id="offers" sx={{ py: { xs: 8, sm: 16 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          maxWidth: '50rem',
          mx: 'auto'
        }}>
        <Typography component="h2" variant="h3">
          What we offer
        </Typography>
        <Typography variant="body1" sx={{ mb: { xs: 2, sm: 4 } }}>
          Unlock Your Marketing Potential with Reach AI. Elevate your campaigns with our
          revolutionary AI-driven platform. Tailored for businesses of all sizes, Reach AI empowers
          you with enterprise-grade digital marketing tools that deliver unparalleled results.
          Harness the power of cutting-edge technology and gain a competitive edge in your industry.
        </Typography>
      </Box>
      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <Grid container item gap={1} sx={{ display: { xs: 'auto', sm: 'none' } }}>
            {items.map(({ title }, index) => (
              <Chip
                key={index}
                label={title}
                onClick={() => handleItemClick(index)}
                sx={{
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'primary.light' : '';
                    }
                    return selectedItemIndex === index ? 'primary.light' : '';
                  },
                  background: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'none' : '';
                    }
                    return selectedItemIndex === index ? 'none' : '';
                  },
                  backgroundColor: selectedItemIndex === index ? 'primary.main' : '',
                  '& .MuiChip-label': {
                    color: selectedItemIndex === index ? '#fff' : ''
                  }
                }}
              />
            ))}
          </Grid>
          <Box
            component={Card}
            variant="outlined"
            sx={{
              display: { xs: 'auto', sm: 'none' },
              mt: 4
            }}>
            <Box
              sx={{
                backgroundImage: `url(${items[selectedItemIndex].image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                minHeight: 280
              }}
            />
            <Box sx={{ px: 2, pb: 2 }}>
              <Typography color="text.primary" variant="body2" fontWeight="bold">
                {selectedFeature.title}
              </Typography>
              <Typography color="text.secondary" variant="body2" sx={{ my: 0.5 }}>
                {selectedFeature.description}
              </Typography>
              <Link
                color="primary"
                variant="body2"
                fontWeight="bold"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  '& > svg': { transition: '0.2s' },
                  '&:hover > svg': { transform: 'translateX(2px)' }
                }}>
                <span>Learn more</span>
                <ChevronRightRoundedIcon fontSize="small" sx={{ mt: '1px', ml: '2px' }} />
              </Link>
            </Box>
          </Box>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            useFlexGap
            sx={{ width: '100%', display: { xs: 'none', sm: 'flex' } }}>
            {items.map(({ icon, title, description }, index) => (
              <Card
                key={index}
                variant="outlined"
                component={Button}
                onClick={() => handleItemClick(index)}
                sx={{
                  p: 3,
                  height: 'fit-content',
                  width: '100%',
                  background: 'none',
                  backgroundColor: selectedItemIndex === index ? 'action.selected' : undefined,
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'primary.light' : 'grey.200';
                    }
                    return selectedItemIndex === index ? 'primary.dark' : 'grey.800';
                  }
                }}>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    textAlign: 'left',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { md: 'center' },
                    gap: 2.5
                  }}>
                  <Box
                    sx={{
                      color: (theme) => {
                        if (theme.palette.mode === 'light') {
                          return selectedItemIndex === index ? 'primary.main' : 'grey.300';
                        }
                        return selectedItemIndex === index ? 'primary.main' : 'grey.700';
                      }
                    }}>
                    {icon}
                  </Box>
                  <Box sx={{ textTransform: 'none' }}>
                    <Typography color="text.primary" variant="body2" fontWeight="bold">
                      {title}
                    </Typography>
                    <Typography color="text.secondary" variant="body2" sx={{ my: 0.5 }}>
                      {description}
                    </Typography>
                    <Link
                      color="primary"
                      variant="body2"
                      fontWeight="bold"
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        '& > svg': { transition: '0.2s' },
                        '&:hover > svg': { transform: 'translateX(2px)' }
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                      }}>
                      <span>Learn more</span>
                      <ChevronRightRoundedIcon fontSize="small" sx={{ mt: '1px', ml: '2px' }} />
                    </Link>
                  </Box>
                </Box>
              </Card>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: { xs: 'none', sm: 'flex' }, width: '100%' }}>
          <Card
            variant="outlined"
            sx={{
              height: '100%',
              width: '100%',
              display: { xs: 'none', sm: 'flex' },
              pointerEvents: 'none'
            }}>
            <Box
              sx={{
                m: 'auto',
                width: 500,
                height: 500,
                backgroundSize: 'contain',
                backgroundImage: `url(${items[selectedItemIndex].image})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
              }}
            />
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
